"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PtEsUsd = exports.PtEsEur = exports.EnEsUsd = exports.EnEsEur = exports.EsEsUsd = exports.EsEsEur = void 0;
class EsEsEur {
    constructor() {
        this.locale = "es-es";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, dd MMMM, yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.EsEsEur = EsEsEur;
class EsEsUsd {
    constructor() {
        this.locale = "es-es";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, dd MMMM, yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "USD",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n",
        };
    }
}
exports.EsEsUsd = EsEsUsd;
class EnEsEur {
    constructor() {
        this.locale = "en-es";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, dd MMMM, yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.EnEsEur = EnEsEur;
class EnEsUsd {
    constructor() {
        this.locale = "en-es";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, dd MMMM, yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "USD",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n",
        };
    }
}
exports.EnEsUsd = EnEsUsd;
class PtEsEur {
    constructor() {
        this.locale = "pt-es";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, dd' de 'MMMM' de 'yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.PtEsEur = PtEsEur;
class PtEsUsd {
    constructor() {
        this.locale = "pt-es";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, dd' de 'MMMM' de 'yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "USD",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n",
        };
    }
}
exports.PtEsUsd = PtEsUsd;
